import { ListItem } from '@/components';
import BarDial from '@/components/atoms/BarDial/BarDial';
import {
  AggregatedMetricsInterface,
  RatingsInterface,
  YieldBearingAssetInterface,
} from '@/interfaces';
import { FC } from 'react';
type RatingType = keyof RatingsInterface;
interface RatingBarDialProps {
  asset: YieldBearingAssetInterface;
  ratingType?: RatingType;
  width?: string;
  height?: string;
}
const RatingBarDial: FC<RatingBarDialProps> = ({
  asset,
  ratingType = 'overallMetrics',
  width = 'w-24',
  height = 'h-4',
}) => {
  const ratingMetrics: AggregatedMetricsInterface | undefined =
    asset.ratings?.[ratingType];
  if (!ratingMetrics) {
    return null;
  }
  return (
    <BarDial
      value={(ratingMetrics.averageRating / 5) * 100}
      width={width}
      height={height}
      editable={false}
      hoverContent={
        ratingMetrics.ratingCount ? (
          <div className="flex flex-col items-start">
            <ListItem
              mainText={`${ratingMetrics.averageRating.toFixed(1)} / 5.0`}
              mainTextColor="accent"
              subSubText={`${ratingMetrics.ratingCount} ratings`}
            />
          </div>
        ) : null
      }
      showBreakpoints={true}
      noOfBreakpoints={5}
    />
  );
};
export default RatingBarDial;
